<template>
  <div class="summary">
    <div class="row amount">
      <span class="label">金額</span>
      <span class="value">NT$ {{ amount ?? 0 }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  amount?: number
}>()
</script>

<style scoped>
.summary {
  background: linear-gradient(135deg, #fff7ed, #ffedd5);
  border-radius: 12px;
  padding: 14px 16px;
}
.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 15px;
}
.label {
  color: #6b7280;
}
.value {
  color: #111827;
  font-weight: 500;
}
.amount .value {
  color: #ea580c;
  font-size: 22px;
  font-weight: 700;
}
</style>
